import { $translate } from '@/utils/i18n';
export default {
    configuration: true,
    searchList: {
        searchTxt: [],
        unfoldState: false,
        advancedBtn: true
    },
    table: {
        selectBtn: false,
        clickState: true,
        leftOperation: true,
        height: 400,
        columns: [
            {
                label: '操作指南名称',
                prop: 'guideName',
                filter: true,
                require: true,
                width: 100
            },
            {
                label: '描述',
                prop: 'description',
                filter: true,
                require: true,
                width: 200
            },
            {
                label: '创建时间',
                prop: 'createTime',
                filter: true,
                require: true,
                width: 80
            },
            {
                label: '状态',
                type: 'switch',
                prop: 'status',
                statesY: $translate('lang.E3202102260004', { defaultText: '启用' }),
                statesN: $translate('lang.E3202102260003', { defaultText: '停用' }),
                filter: true,
                require: true,
                width: 50
            }
        ],
        action: [
            {
                type: 'text',
                label: '编辑',
                size: 'small',
                event: 'edit'
            },
            {
                type: 'text',
                label: '删除',
                size: 'small',
                event: 'delete'
            }
        ],
        leftWidth: '100px'
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 10,
        pageNo: 1,
        pageSizes: [10, 20, 30, 50, 100]
    },
    showPage: true
};
